export default __webpack_public_path__ + "static/sharing-link-image-a4b7bdee30cd3bb9d8b6ad69d6500b9f.png";